// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3jFNA","imageUploader":"EGiftCard_imageUploader__yaAkn"};